import { SurveyResponse } from '../../shared/models/survey/survey-response.model';

export class SurveyInstance {
    id: number;
    title: string;
    description: string;
    questions: SurveyResponse[];
    locked: boolean;
    answered: boolean;
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/survey-instance.model.ts